import { render, staticRenderFns } from "./CmgReferralJoinSuccessModal.vue?vue&type=template&id=29a4ec29&scoped=true&lang=pug"
import script from "./cmg-referral-join-success-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-referral-join-success-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgReferralJoinSuccessModal.vue?vue&type=style&index=0&id=29a4ec29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a4ec29",
  null
  
)

export default component.exports